import axios from 'axios';
import axiosConfig from '../../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';
import csrfToken from '../../../shared/meta';

configure({ axiosConfig });

const headers = {
  'X-CSRF-TOKEN': csrfToken(),
};

const base = '/api/v1/lwadmin/navigation_item';

export function useGetNavigationItems() {
  return useAxios({
    cache: { ignoreCache: true },
    url: `${base}s`,
    method: 'GET',
  }, { manual: true });
}

export function createNavigationItem(payload) {
  return axios.post(base, payload, { headers });
}

export function updateNavigationItem(id, payload) {
  return axios.put(`${base}/${id}`, payload, { headers });
}

export function publishNavigationItem(id) {
  return axios.put(`${base}/${id}/publish`, { headers });
}

export function unpublishNavigationItem(id) {
  return axios.put(`${base}/${id}/unpublish`, { headers });
}

export function deleteNavigationItem(id) {
  return axios.delete(`${base}/${id}`, { headers });
}
